import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'SpacePublisherPage.Title',
    defaultMessage: 'Publisher'
  },
  loading: {
    id: 'Loading',
    defaultMessage: 'Loading...'
  }
})
